<template>
  <div class="page">
    <div class="top-div">
      <van-nav-bar title="户号管理">
         <template #left>
          <img src="../../assets/accountNumberManagement/close.png" width="24px" @click="onClickLeft()">
        </template>
      </van-nav-bar>
    </div>
    <div class="bottom-div">
      <div class="body-div">
        <div class="card-div" @click="toService(item)" v-for="(item, index) in userGasList" :key="index">
          <div class="card-top-div">
            <div class="top-left-cell">
              <img src="../../assets/accountNumberManagement/gas.png" width="19px">
              <span class="title-span">{{item.label}}</span>
            </div>
            <div class="top-right-cell">
              <img src="../../assets/accountNumberManagement/delete-red.png" width="18px" @click.stop="toDelete(item)">
            </div>
          </div>
          <van-divider :style="{ color: '#ECECEC', borderColor: '#ECECEC', margin: '0' }"/>
          <div class="card-bottom-div">
            <div class="line-div">
              <div class="left-cell left-text">用户编号：</div>
              <div class="right-cell right-text">{{item.userCode}}</div>
            </div>
            <div class="line-div middle-line">
              <div class="left-cell left-text">表型：</div>
              <div class="right-cell right-text">
                {{item.meterType == 'C' ? '卡表' : item.meterType == 'R' ? '普表' : item.meterType == 'NB' ? '智能表' :
                item.meterType}}
              </div>
            </div>
            <div class="line-div">
              <div class="left-cell left-text">地址：</div>
              <div class="right-cell right-text">{{item.address}}</div>
            </div>
          </div>
        </div>
        <div v-if="userGasList.length < code" class="card-div add-card" @click="toAddAccountNumber()">
          <img src="../../assets/accountNumberManagement/add.png" width="32px">
          <div class="add-number-text">添加新用户编号</div>
        </div>
      </div>
    </div>
    <van-dialog v-model="showDelete" title="取消户号" show-cancel-button confirmButtonText="确认删除"
                @confirm="onDeleteConfirm()">
      <div class="delete-div">该操作将在列表中删除用户</div>
    </van-dialog>
  </div>
</template>

<script>
import { getUserGasList, unbindUserGas } from '../../api/accountNumberManagement'

export default {
  name: 'AccountNumberManagement',
  data () {
    return {
      showDelete: false, // 是否显示删除弹框
      userGasList: [], // 户号列表
      toDeleteUserCode: {}, // 要删除的户号
      code: '' // 可以绑定的户号数
    }
  },
  mounted () {
    if (this.$route.query.title) {
      window.localStorage.pageTitle = this.$route.query.title;
    }
    this.goAuthenticationUserLogin();
    /*if (window.localStorage.token) {
      this.getUserGasList()
    } else {
      this.$router.push('/login')
    }*/
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    toService (val) {
      /*this.$router.push({
        name: 'Service'
      })*/
      if (window.localStorage.pageTitle == '查询') {
        this.$router.push('/accountInformation')
      } else if (window.localStorage.pageTitle == '发票') {
        this.$router.push('/bill')
      } else {
        this.$router.push('/repair')
      }
      this.$store.commit('setCardObj', val)
    },

    // 添加新用户编号
    toAddAccountNumber () {
      this.$router.push('/addAccountNumber')
    },

    // 删除户号
    toDelete (item) {
      this.toDeleteUserCode = item
      this.showDelete = true
    },

    // 获取用户绑定的燃气号列表
    getUserGasList () {
      const that = this
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        userId: window.localStorage.userId
      }
      getUserGasList(params).then(res => {
        if (res.data.success) {
          that.code = res.data.code
          that.userGasList = res.data.rows
          that.$toast.clear()
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch(() => {
        /*that.$toast.fail('登录已过期，请重新登录')
        this.$router.push('/login')*/
      })
    },

    // 确认删除户号
    onDeleteConfirm() {
      const that = this
      const params = {
        id: that.toDeleteUserCode.id
      }
      unbindUserGas(params).then(res => {
        if (res.data.success) {
          that.$toast.success(res.message)
          that.getUserGasList();
        } else {
          that.$toast.fail(res.message)
        }
      }).catch(() => {
        that.$toast.fail('取消户号失败')
      })
    },

    // 用户登录
    goAuthenticationUserLogin () {
      let url = ''
      if (window.localStorage.pageTitle == '查询') {
        url = 'https://t200renzheng.zhengtoon.com/open/m/login/goUserLogin?client_id=20220418003&redirect_uri=https://zttest.bjgas.com/resource/AppH5_sit/%23/accountInformation&response_type=code&scope=user_info&state='
      } else if (window.localStorage.pageTitle == '发票') {
        url = 'https://t200renzheng.zhengtoon.com/open/m/login/goUserLogin?client_id=20220418005&redirect_uri=https://zttest.bjgas.com/resource/AppH5_sit/%23/bill&response_type=code&scope=user_info&state='
      } else {
        url = 'https://t200renzheng.zhengtoon.com/open/m/login/goUserLogin?client_id=20220418004&redirect_uri=https://zttest.bjgas.com/resource/AppH5_sit/%23/repair&response_type=code&scope=user_info&state='
      }
      window.location.href = url;
    }
  }
}
</script>

<style scoped>
  .top-div {
    background-color: #CE0022;
    height: 17%;
  }

  .bottom-div {
    background-color: #F7F8FA;
    height: 83%;
    padding: 0 4%;
  }

  .page {
    height: 100%;
  }

  .van-nav-bar {
    background-color: transparent;
  }

  /deep/ .van-nav-bar__title {
    color: #FFF;
  }

  .body-div {
    position: absolute;
    width: 92%;
    height: 92%;
    top: 58px;
    overflow: auto;
  }

  .card-top-div {
    padding: 0 5% 10px 5%;
    display: flex;
  }

  .card-bottom-div {
    padding: 12px 5%;
  }

  .left-cell {
    width: 28%;
    text-align: left;
  }

  .top-left-cell {
    width: 80%;
    text-align: left;
  }

  .right-cell {
    width: 72%;
    text-align: right;
  }

  .top-right-cell {
    width: 20%;
    text-align: right;
  }

  .card-div {
    background-color: #FFF;
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .title-span {
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #27282E;
    margin-left: 8px;
  }

  .line-div {
    display: flex;
  }

  .left-text {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #62667A;
  }

  .right-text {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
  }

  .middle-line {
    margin: 10px 0;
  }

  .add-number-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .add-card {
    padding: 12px 0;
    text-align: center;
  }

  .delete-div {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #999999;
    text-align: center;
    margin-bottom: 28px;
  }

  /deep/ .van-dialog__header {
    padding-top: 15px;
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #27282E;
    padding-bottom: 12px;
  }

  /deep/ .van-dialog__cancel {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #26282E;
  }

  /deep/ .van-dialog__confirm {
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #CE0022;
  }
</style>
